// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lyE6dN0zPcEtwe {
  display: inline-flex;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  width: 28px;
  max-width: 128px;
  height: 28px;
  max-height: 128px;
  overflow: hidden;
  border: 0;
  border-radius: var(--ds-border-radius-circle, 100%);
  opacity: 1;
  background-color: var(--ds-background-accent-gray-subtler, #dcdfe4);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  color: var(--ds-icon, #44546f);
  font-family: var(--ds-font-family-body, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
  font-size: 12px;
  font-weight: var(--ds-font-weight-bold, bold);
  line-height: 28px;
  white-space: nowrap;
  -webkit-print-color-adjust: exact;
}
.lyE6dN0zPcEtwe.xhbVjffP1E8AY1 {
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
  color: var(--ds-icon-subtle, #626f86);
}
.lyE6dN0zPcEtwe.ustrwxEVi_HEQ_ {
  color: var(--ds-text-subtle, #44546f);
}
.lyE6dN0zPcEtwe.YwlLIicTypI8kv {
  border: 1px solid var(--ds-background-accent-gray-subtler, #dcdfe4);
  background-color: var(--ds-background-accent-gray-subtler, #dcdfe4);
}
.lyE6dN0zPcEtwe.YwlLIicTypI8kv.xhbVjffP1E8AY1 {
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
}
.a8VwllJRmDFRmQ.lyE6dN0zPcEtwe {
  margin-top: var(--ds-space-050, 4px);
  margin-left: var(--ds-space-050, 4px);
  float: right;
}
.EHQQXZBy7v7uTh.lyE6dN0zPcEtwe {
  flex: 0 0 auto;
  align-self: flex-start;
}
`, ""]);
// Exports
export var avatar = `lyE6dN0zPcEtwe`;
export var deactivated = `xhbVjffP1E8AY1`;
export var isGhost = `ustrwxEVi_HEQ_`;
export var lightBackground = `YwlLIicTypI8kv`;
export var cardFront = `a8VwllJRmDFRmQ`;
export var detailHeader = `EHQQXZBy7v7uTh`;
export default ___CSS_LOADER_EXPORT___;
